import React from "react";
import { Field } from "formik";
import CustomInputTextComponent from "components/Form/CustomInputTextComponent";
import { CompactPicker } from "react-color";
import { Checkbox } from "components/Form/SpecialButtons";

const popover = {
	position: "absolute",
	zIndex: "2",
};
const cover = {
	position: "fixed",
	top: "0px",
	right: "0px",
	bottom: "0px",
	left: "0px",
};

const GeneralForm = ({ element, colorPicker, closeColorPicker, openColorPicker, setFieldValue, values }) => (
	<div>
		<Field type="text" name="label" customlabel="Libellé du pack" component={CustomInputTextComponent} required />
		<Field type="text" name="name" customlabel="Libellé court" component={CustomInputTextComponent} />
		<div style={{ position: "relative" }}>
			{colorPicker ? (
				<div style={popover}>
					<div style={cover} onClick={closeColorPicker} />
					<CompactPicker
						color={values["color"]}
						onChangeComplete={(values) => {
							setFieldValue("color", values.hex);
							closeColorPicker();
						}}
					/>
				</div>
			) : null}

			<Field
				type="text"
				onClick={(e) => {
					if (e !== undefined) e.preventDefault();
					openColorPicker();
				}}
				name="color"
				style={{ display: "none" }}
				customlabel="Couleur"
				component={CustomInputTextComponent}
				required
			/>

			<div
				style={{
					width: 20,
					height: 20,
					borderRadius: "50%",
					backgroundColor: values["color"],
					top: 30,
					right: 10,
					position: "absolute",
					border: "1px solid #ccc",
				}}
			></div>
		</div>
		<Field type="text" name="group" customlabel="Regroupement" component={CustomInputTextComponent} />
		<Field type="text" name="doctor" customlabel="Code Prescripteur" component={CustomInputTextComponent} />
		<Field customlabel="Seulement pour les campagnes" component={Checkbox} name="only_for_campaign" id="only_for_campaign" required />
		<Field customlabel="Seulement pour les dépôts express" component={Checkbox} name="only_for_deposit" id="only_for_deposit" required />
	</div>
);

export default GeneralForm;
